import { Component } from '@angular/core';
import { NavParams, NavController, Events, AlertController } from 'ionic-angular';
import { Http, Response } from '@angular/http';
import {Observable} from 'rxjs/Observable';

@Component({
  selector: 'modal',
  templateUrl: 'modal.html'
})

export class ModalOcorrencias {

  public id;
  public nome;
  public usuario;
  public data;
  public sintomas;
  public doenca;

  constructor(params: NavParams, private navCtrl: NavController, private http: Http, public events: Events, private alertCtrl: AlertController) {
    this.id = params.get('id');
    this.nome = params.get('nome');
    this.usuario = params.get('usuario');
    this.data = params.get('data');
    this.sintomas = params.get('sintomas');
    this.doenca = (params.get('doenca') ? params.get('doenca') : "");
  }

  apagarOcorrencia(id){
    let alert = this.alertCtrl.create({
    message: 'Tem certeza de que deseja apagar a ocorrência?',
    buttons: [
      {
        text: 'Não',
        role: 'cancel',
      },
      {
        text: 'Sim',
        handler: () => {
          

          this.respApagarOcorrencia(id).subscribe(data => {
            let alert = this.alertCtrl.create({
              subTitle: 'Ocorrência apagada com sucesso!',
              buttons: ['OK']
            });
            alert.present();
            this.fecharModal();
            this.events.publish('ocorrenciaApagada');
          });
          
        }
      }
    ]
  });
  alert.present();
  }

  respApagarOcorrencia(id): Observable<any> {
    return this.http.get("http://maisalguemdoente.com.br/ocorrencias/webService/removeOcorrencia?id="+id).map((res: Response) => res.json());
  }

  fecharModal(){
    this.navCtrl.pop();
  }
}


// WEBPACK FOOTER //
// ./src/pages/ocorrencias/modal.ts